import { useRef, useEffect } from 'react';
import { castArray, noop } from 'lodash';

const EVENT_NAME = 'mousedown';

/**
 * Custom hook which can be used to run a callback if the user clicks outside of a ref
 * or an array of refs
 *
 * @param {Ref|Ref[]} targetElOrEls
 * @param {Function} callback
 */
export default function useOnClickOutside(targetElOrEls, callback) {
    const callbackRef = useRef();
    const targetRefs = useRef();
    callbackRef.current = callback || noop;
    targetRefs.current = castArray(targetElOrEls);

    useEffect(() => {
        document.addEventListener(EVENT_NAME, clickHandler);

        return () => {
            document.removeEventListener(EVENT_NAME, clickHandler);
        };
    }, []);

    function clickHandler(e) {
        const clickedRefs = targetRefs.current?.filter((ref) => clickedInRef(e, ref));

        if (!clickedRefs?.length) {
            callbackRef.current();
        }
    }
}

function clickedInRef(event, ref) {
    if (ref.current && ref.current.contains(event.target)) {
        return true;
    }

    return false;
}
